import { Form, Alert } from "react-bootstrap";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import ButtonLoginWithGoogle from "../ButtonLoginWithGoogle";
import GlobalContext from "../../context/GlobalContext";
import swal from "../../services/swalConfig";
import { useTranslation } from "react-i18next";

const AuthLoginForm = ({
  registrationMessage = "",
  onDismissMessage,
  onRequireRegister,
  onSuccess,
  showGoogle = true,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm();
  const { setLoading, loginApiCall } = useContext(GlobalContext);
  const { t } = useTranslation(["auth", "common"]);

  const submitHandler = async (data) => {
    setLoading(true);

    try {
      const response = await loginApiCall(data);

      if (response?.status === 400 && response?.errors) {
        Object.keys(response.errors).forEach((key) => {
          setError(key, {
            type: "manual",
            message: response.errors[key],
          });
        });
        return;
      }

      if (response?.status !== 200) {
        swal.fire({
          title: t("common:errors.oops"),
          text: response?.message || t("common:errors.login_failed"),
          icon: "error",
          showCancelButton: false,
        });
        return;
      }

      if (onSuccess) {
        onSuccess(response);
      }
    } catch (error) {
      swal.fire({
        title: t("common:errors.oops"),
        text: t("common:errors.login_failed"),
        icon: "error",
        showCancelButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {registrationMessage && (
        <Alert
          variant="primary"
          dismissible
          onClose={() => onDismissMessage?.()}
        >
          {registrationMessage}
        </Alert>
      )}

      <Form
        className="modal-login-popup mt-3"
        onSubmit={handleSubmit(submitHandler)}
      >
        <Form.Group className="mb-3" controlId="auth-login-email">
          <Form.Label>{t("login.email")}</Form.Label>
          <Form.Control
            {...register("email", {
              required: t("validation.email_required"),
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: t("validation.email_invalid"),
              },
            })}
            type="email"
            placeholder={t("login.email_placeholder")}
          />
          {errors.email ? (
            <small className="text-danger">{errors.email.message}</small>
          ) : null}
        </Form.Group>

        <Form.Group className="mb-3" controlId="auth-login-password">
          <Form.Label>{t("login.password")}</Form.Label>
          <Form.Control
            {...register("password", {
              required: t("validation.password_required"),
            })}
            type="password"
            placeholder={t("login.password_placeholder")}
          />
          {errors.password ? (
            <small className="text-danger">{errors.password.message}</small>
          ) : null}
        </Form.Group>

        <div className="text-center">
          <button type="submit" className="w-100 btn-modal-login border-0">
            {t("login.submit")}
          </button>
        </div>
      </Form>

      {showGoogle && (
        <>
          <span className="text-middle-of-line mt-3">{t("or")}</span>
          <div className="text-center mt-3 mb-3">
            <ButtonLoginWithGoogle />
          </div>
        </>
      )}

      {onRequireRegister && (
        <p className="text-center mb-0">
          {t("login.no_account")}{" "}
          <button
            type="button"
            className="btn btn-link p-0 text-decoration-none"
            onClick={onRequireRegister}
          >
            <b>{t("login.register_link")}</b>
          </button>
        </p>
      )}
    </>
  );
};

export default AuthLoginForm;
